/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BatchSortFeaturedShows,
    PatchFeaturedShowRequest,
} from '../models';

export interface FeaturedShowApiControllerBatchSortFeaturedShowRequest {
    batchSortFeaturedShows: BatchSortFeaturedShows;
}

export interface FeaturedShowApiControllerDeleteFeaturedShowRequest {
    featuredShowId: string;
}

export interface FeaturedShowApiControllerPatchFeaturedShowRequest {
    featuredShowId: string;
    patchFeaturedShowRequest: PatchFeaturedShowRequest;
}

export interface FeaturedShowApiControllerRemoveAutoFeaturedPropertyRequest {
    featuredShowId: string;
}

/**
 * 
 */
export class FeaturedShowApi extends runtime.BaseAPI {

    /**
     */
    async featuredShowApiControllerBatchSortFeaturedShowRaw(requestParameters: FeaturedShowApiControllerBatchSortFeaturedShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.batchSortFeaturedShows === null || requestParameters.batchSortFeaturedShows === undefined) {
            throw new runtime.RequiredError('batchSortFeaturedShows','Required parameter requestParameters.batchSortFeaturedShows was null or undefined when calling featuredShowApiControllerBatchSortFeaturedShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-shows:batch-sort`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchSortFeaturedShows,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featuredShowApiControllerBatchSortFeaturedShow(requestParameters: FeaturedShowApiControllerBatchSortFeaturedShowRequest): Promise<void> {
        await this.featuredShowApiControllerBatchSortFeaturedShowRaw(requestParameters);
    }

    /**
     */
    async featuredShowApiControllerDeleteFeaturedShowRaw(requestParameters: FeaturedShowApiControllerDeleteFeaturedShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.featuredShowId === null || requestParameters.featuredShowId === undefined) {
            throw new runtime.RequiredError('featuredShowId','Required parameter requestParameters.featuredShowId was null or undefined when calling featuredShowApiControllerDeleteFeaturedShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-shows/{featuredShowId}`.replace(`{${"featuredShowId"}}`, encodeURIComponent(String(requestParameters.featuredShowId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featuredShowApiControllerDeleteFeaturedShow(requestParameters: FeaturedShowApiControllerDeleteFeaturedShowRequest): Promise<void> {
        await this.featuredShowApiControllerDeleteFeaturedShowRaw(requestParameters);
    }

    /**
     */
    async featuredShowApiControllerPatchFeaturedShowRaw(requestParameters: FeaturedShowApiControllerPatchFeaturedShowRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.featuredShowId === null || requestParameters.featuredShowId === undefined) {
            throw new runtime.RequiredError('featuredShowId','Required parameter requestParameters.featuredShowId was null or undefined when calling featuredShowApiControllerPatchFeaturedShow.');
        }

        if (requestParameters.patchFeaturedShowRequest === null || requestParameters.patchFeaturedShowRequest === undefined) {
            throw new runtime.RequiredError('patchFeaturedShowRequest','Required parameter requestParameters.patchFeaturedShowRequest was null or undefined when calling featuredShowApiControllerPatchFeaturedShow.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-shows/{featuredShowId}`.replace(`{${"featuredShowId"}}`, encodeURIComponent(String(requestParameters.featuredShowId))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.patchFeaturedShowRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featuredShowApiControllerPatchFeaturedShow(requestParameters: FeaturedShowApiControllerPatchFeaturedShowRequest): Promise<void> {
        await this.featuredShowApiControllerPatchFeaturedShowRaw(requestParameters);
    }

    /**
     */
    async featuredShowApiControllerRemoveAutoFeaturedPropertyRaw(requestParameters: FeaturedShowApiControllerRemoveAutoFeaturedPropertyRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.featuredShowId === null || requestParameters.featuredShowId === undefined) {
            throw new runtime.RequiredError('featuredShowId','Required parameter requestParameters.featuredShowId was null or undefined when calling featuredShowApiControllerRemoveAutoFeaturedProperty.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/featured-shows/{featuredShowId}:removeAutoFeatured`.replace(`{${"featuredShowId"}}`, encodeURIComponent(String(requestParameters.featuredShowId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async featuredShowApiControllerRemoveAutoFeaturedProperty(requestParameters: FeaturedShowApiControllerRemoveAutoFeaturedPropertyRequest): Promise<void> {
        await this.featuredShowApiControllerRemoveAutoFeaturedPropertyRaw(requestParameters);
    }

}
